/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerType = {
    Individual: 'INDIVIDUAL',
    Company: 'COMPANY'
} as const;
export type CustomerType = typeof CustomerType[keyof typeof CustomerType];

